import { UserInfoEntity } from "@/domain/entity/user-info-entity";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchHeaderUserInfoUsecase {
  //MARK:- init
  constructor(private readonly userRepo: UserRepository) {}

  //MARK: - execute
  async execute(): Promise<SATResult<UserInfoEntity, SATError>> {
    const userInfoResult = await this.userRepo.getUserInfo();
    if (userInfoResult.isFailure) {
      return SATResult.failure(userInfoResult.error);
    }

    console.log(
      "[FetchHeaderUserInfoUsecase] :: execute :: 유저 정보를 조회합니다.",
      userInfoResult.value
    );
    return SATResult.success(userInfoResult.value);
  }
}
